export var SurveyEvents;
(function (SurveyEvents) {
    SurveyEvents["CreateModule"] = "module_create";
    SurveyEvents["CreateContent"] = "content_create";
    SurveyEvents["CreateMentorship"] = "mentorship_create";
})(SurveyEvents || (SurveyEvents = {}));
